import { render, staticRenderFns } from "./categoryKeywords.vue?vue&type=template&id=2ceb251c&scoped=true"
import script from "./categoryKeywords.vue?vue&type=script&lang=js"
export * from "./categoryKeywords.vue?vue&type=script&lang=js"
import style0 from "./categoryKeywords.vue?vue&type=style&index=0&id=2ceb251c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb251c",
  null
  
)

export default component.exports